module.exports = new __parcel__URL__("name_screen_text.f613f836.png").toString();